<template>
  <div class="application">
    <div>
      <DemandStatusLabel
        v-if="$_shouldDisplayDemandStatus(demand)"
        :is-demand-filled="demand.isFilled()"
        :is-favorite="demand.isBookingExpress()"
        :demand-color="color"
        :candidate-applied-count="demand.getAppliedCandidateAmount()"
        :has-candidate="demand.hasCandidate()"
        :contract-type="demand.getType()"
      />
      <!-- Should display cancellation candidate count -->
      <DemandStatusLabel
        v-if="!demand.isFilled() && !demand.isBookingExpress() && demand.getCandidateCancellationCount()"
        :contract-type="demand.getType()"
        :demand-color="color"
        :candidate-cancellation-count="demand.getCandidateCancellationCount()"
      />
      <!-- Should display selected candidate count -->
      <DemandStatusLabel
        v-if="!demand.isFilled() && !demand.isBookingExpress() && demand.getSelectedCandidateAmount()"
        :demand-color="color"
        :candidate-selected-count="demand.getSelectedCandidateAmount()"
        :has-candidate="demand.hasCandidate()"
        :contract-type="demand.getType()"
      />
    </div>
  </div>
</template>

<script>
  import { RecruitmentDashboardModel } from "@core/models";
  import { dashboardDemandMixin } from "@etab/mixins";

  import DemandStatusLabel from "../DemandStatusLabel.component.vue";

  export default {
    components: {
      DemandStatusLabel,
    },
    mixins: [dashboardDemandMixin],
    props: {
      demand: {
        type: Object,
        default: () => new RecruitmentDashboardModel(),
      },
      color: {
        type: String,
        default: "",
      },
    },
  };
</script>

<style lang="scss" scoped>
  .application {
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
</style>
